// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconExternal: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="11" viewBox="0 0 10 11" fill="currentColor">
            <path
                d="M7.5,6.25 C7.15488285,6.25 6.8750003,6.52988255 6.8750003,6.875 L6.8750003,8.75 L1.2500003,8.75 L1.2500003,3.125 L3.1250003,3.125 C3.47011745,3.125 3.7500003,2.84531236 3.7500003,2.5 C3.7500003,2.15468764 3.47011745,1.875 3.1250003,1.875 L1.2500003,1.875 C0.559570491,1.875 0,2.43457019 0,3.125 L0,8.75 C0,9.4402343 0.559570193,10 1.25,10 L6.875,10 C7.56542981,10 8.125,9.4402343 8.125,8.75 L8.125,6.875 C8.125,6.52929664 7.84570336,6.25 7.5,6.25 L7.5,6.25 Z M9.81640637,0.182949305 C9.70312476,0.0698828697 9.54687476,0 9.375,0 L6.25,0 C5.90488255,0 5.64257801,0.279687643 5.64257801,0.607421994 C5.64257801,0.952538848 5.92226565,1.21484399 6.2673825,1.21484399 L7.88359344,1.21484399 L3.49023432,5.67773461 C3.24609369,5.92187524 3.24609369,6.31757855 3.49023432,6.56171918 C3.73437494,6.80664062 4.13085938,6.80664062 4.375,6.5625 L8.75,2.13281274 L8.75,3.75 C8.75,4.09511715 9.02988255,4.35742199 9.35742199,4.35742199 C9.68496144,4.35742199 10,4.09570307 10,3.75 L10,0.607421994 C10,0.452343822 9.92968738,0.296093822 9.81640637,0.182949305 Z"
                transform="translate(0 .25)"
            />
        </svg>
    );
};

export default React.memo(IconExternal);
